// Translation: Ukrainian > Server
const server = Object.freeze({
	errorItems: {
		'err.2FA_already_enabled': '',
		'err.account_disabled': '',
		'err.account_locked_temporary': '',
		'err.already_send': '',
		'err.already_verified': '',
		'err.auth_service_down': '',
		'err.captcha_validation_failed': '',
		'err.code_sent_recently': '',
		'err.email_already_exists': '',
		'err.email_is_not_valid': '',
		'err.email_not_exists': '',
		'err.exists': '',
		'err.exist_email': '',
		'err.invalid_code': '',
		'err.not_found': '',
		'err.user_not_exists': '',
		'err.wrong_old_password': '',
		'err.wrong_username_or_password': '',
		'err.wrong_verification_code': ''
	}
})

// Export
export default server
